import React, { useState, useEffect } from 'react';
import clsx from 'clsx';

import ExperienceAvailabilityPageComponent from '../ExperienceAvailabilityPage';

import { DialogCore } from './components';
import { ExperienceDetails } from './components';

import useStyles from './styles';
import {
  AvailabilityCalendarProps,
  Experience,
  Slot,
  VisibleRange,
} from './types';

const AvailabilityCalendar: React.FC<AvailabilityCalendarProps> = ({
  initialExperience,
  experienceId,
  code = null,
  fullScreenMode = false,
  getById, // ESTA ES LA FUNCION QUE RECIBE PARA TRAER LOS DATOS DE LA EXPERIENCIA (FIXME)
  getAvailability, // ESTA ES LA FUNCION QUE RECIBE PARA CONSULTAR LA DSPONIBILIDAD
  addBookedExperienceWithQuantityPrice, // ESTO SE USA SOLO EN VIAJERO Y LE AGREGA EL PRECIO Y LA CANTIDAD A UN OBJETO EXPErIENCIA (CHECKOUt) (FIXME)
  setTimeOfArrival, // ESTO SE USA SOLO EN VIAJERO Y ES UN USESTATE DEL DATETIME DE LA RESERVA (CHECKOUt) (FIXME)
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [datePicker, setDatePicker] = useState(new Date());
  const [experience, setExperience] = useState<Experience | any>(
    initialExperience ?? {}
  );
  const [visibleRange, setVisibleRange] = useState<VisibleRange>({
    start: null,
    end: null,
  });

  const [slots, setSlots] = useState<Slot[] | undefined>();

  const [isScrolled, setIsScrolled] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    const handleScroll = () => {
      if (!isScrolled && window.scrollY > 28) {
        setIsScrolled(true);
      } else if (isScrolled && window.scrollY <= 28) {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isScrolled]);

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  useEffect(() => {
    if (!experienceId) {
      return;
    }

    if (getById) {
      getById(experienceId).then(setExperience);
    }
  }, [experienceId]);

  useEffect(() => {
    if (!experience) {
      return;
    }

    if (
      Date.parse(visibleRange.start as string) &&
      Date.parse(visibleRange.end as string)
    ) {
      setLoading(true);
      if (getAvailability) {
        getAvailability({
          expId: experience.id,
          fromDateTime: new Date(visibleRange.start as string),
          toDateTime: new Date(visibleRange.end as string),
          groupSize: quantity,
          code,
        })
          .then((res) => {
            setSlots([...res]);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }
  }, [experience, quantity, visibleRange]);

  return (
    <div
      className={clsx(
        !fullScreenMode && classes.calendar,
        !fullScreenMode && isScrolled ? classes.fixed : classes.normal
      )}>
      <ExperienceAvailabilityPageComponent
        showLoading={loading}
        showPrice={false}
        quantity={quantity}
        setQuantity={setQuantity}
        setDatePicker={setDatePicker}
        datePicker={datePicker}
        slots={slots as Slot[]}
        experience={experience}
        setSelectedSlot={(item: any) => {
          setSelectedSlot(item);
          if (addBookedExperienceWithQuantityPrice) {
            addBookedExperienceWithQuantityPrice(
              { ...experience, ...item },
              item.price * quantity,
              quantity
            );
          }
          if (setTimeOfArrival) {
            setTimeOfArrival(item.startUTC);
          }
          setDialogOpen(item);
        }}
        setVisibleRange={setVisibleRange}
        resourceSelected={null} // TS
        setResourceSelected={() => {}} // TS
      />
      <DialogCore
        isOpen={dialogOpen}
        onClose={handleCloseDialog}
        title=""
        content={
          <ExperienceDetails
            info={selectedSlot as any}
            quantity={quantity}
            experience={experience}
          />
        }
      />
    </div>
  );
};

export default AvailabilityCalendar;
